export default __webpack_public_path__ + "static/media/CorprateConfig.c661d230.svg";